import packageJson from '../../package.json';

export default packageJson.version.replace(
  /(-SNAPSHOT)?$/i,
  '-' + (process.env.BUILD_NUMBER || 'SNAPSHOT')
);
